export default __webpack_public_path__ + "8f41dc3797fcc8988c3e35beb9411530.png";